import Typography from 'components/Typography';
import { useMemoTranslations } from 'hooks/Intl';
import styles from './index.module.scss';
import * as translations from 'intls/apiKey';
import { ApiKeyCapabilityEnum } from 'constants/ApiKey';
import { FormikProps } from 'formik';
import CapabilityCheckbox from './CapabilityCheckbox';
import { FormSchema } from './types';
import Input from 'components/Input';
import { useEffect } from 'react';
import FooterButtons from 'components/FooterButtons/FooterButtons';

interface FormProps {
  formikProps: FormikProps<FormSchema>;
}

const Form = ({ formikProps }: FormProps) => {
  const { values, handleSubmit, setFieldValue } = formikProps;

  const intl = useMemoTranslations(translations);

  useEffect(() => {
    const { domains } = values;

    if (domains.length === 0) {
      setFieldValue('domains', ['']);
    } else if (domains.at(-2) !== undefined && domains.at(-2)!.length === 0) {
      setFieldValue('domains', values.domains.slice(0, -1));
    } else if (domains.at(-1) !== undefined && domains.at(-1)!.length > 0) {
      setFieldValue('domains', [...values.domains, '']);
    }
  }, [values.domains]);

  return (
    <>
      <Typography
        color="primary"
        type="label"
        className={styles.capabilitiesLabel}
      >
        {intl.CAPABILITIES}
      </Typography>
      <CapabilityCheckbox
        capability={ApiKeyCapabilityEnum.MEDICINE_EQUIVALENCY}
        formikProps={formikProps}
      />
      <Typography color="primary" type="label" className={styles.domainsLabel}>
        {intl.DOMAINS}
      </Typography>
      {values.domains.map((_, index) => (
        <Input
          key={index}
          label="http://example.com"
          showUpperLabel={false}
          name={`domains.${index}`}
          formikProps={formikProps}
        />
      ))}
      <FooterButtons onClickButton={handleSubmit} />
    </>
  );
};

export default Form;
